import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ContactSection from "@/components/ContactSection";
import SEO from "@/components/SEO";
import BreadcrumbSchema from "@/components/BreadcrumbSchema";
import { Beef, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import bannerImage from "@/assets/mangimi-stalla.jpg";

const MangimiAllevamento = () => {
  const products = [
    {
      name: "Mangimi per bovini",
      description: "Mangimi completi e integrati per bovini da carne e da latte",
      features: ["Mangimi per vitelli", "Farine per bovini adulti", "Integratori minerali", "Mangimi biologici certificati"]
    },
    {
      name: "Mangimi per suini",
      description: "Alimenti specifici per tutte le fasi dell'allevamento suino",
      features: ["Mangimi per svezzamento", "Farine per ingrasso", "Integratori minerali", "Formulazioni specifiche"]
    },
    {
      name: "Mangimi per ovini e caprini",
      description: "Prodotti studiati per le esigenze nutrizionali di pecore e capre",
      features: ["Mangimi per agnelli", "Integratori minerali", "Farine per lattazione", "Prodotti per pascolo"]
    },
    {
      name: "Pollame e conigli",
      description: "Alimenti completi per avicoltura e cunicoltura",
      features: ["Mangimi per polli", "Alimenti per volatili", "Mangimi per conigli", "Integratori vitaminici"]
    }
  ];

  return (
    <div className="min-h-screen">
      <SEO
        title="Mangimi Zootecnici e da Allevamento - Magione"
        description="Mangimi zootecnici per bovini, suini, ovini, pollame e conigli. Farine, integratori minerali e mangimi biologici certificati. A Magione (PG), tra Perugia e il Trasimeno."
        canonical="/prodotti/mangimi-allevamento"
        type="product"
      />
      <BreadcrumbSchema items={[
        { name: "Home", url: "/" },
        { name: "Mangimi Allevamento", url: "/prodotti/mangimi-allevamento" }
      ]} />
      <Navbar />

      {/* Hero Banner Section */}
      <section className="relative h-[450px] md:h-[500px] overflow-hidden pt-24 md:pt-28">
        {/* Background Image */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${bannerImage})` }}
        />
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70" />

        {/* Content */}
        <div className="relative container mx-auto px-4 h-full flex flex-col justify-start md:justify-center pt-2 md:pt-0">
          <Link to="/#prodotti" className="mb-6 w-fit">
            <Button variant="outline" className="bg-white/10 text-white border-white/30 hover:bg-white/20 backdrop-blur-sm">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Torna ai prodotti
            </Button>
          </Link>

          <div className="max-w-4xl">
            <div className="icon-wrapper mb-6 w-16 h-16 text-white hidden md:flex items-center justify-center">
              <Beef className="w-12 h-12" />
            </div>
            <h1 className="text-4xl md:text-5xl font-heading font-bold mb-6 text-white">
              Mangimi per Allevamento
            </h1>
            <p className="text-xl text-white/90 max-w-3xl">
              Mangimi di qualità per bovini, suini, ovini e pollame. Prodotti formulati
              per garantire il massimo rendimento e il benessere degli animali.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 max-w-7xl mx-auto">
            {products.map((product, index) => (
              <div
                key={index}
                className="bg-card rounded-2xl p-8 border border-border card-hover"
              >
                <h3 className="text-2xl font-heading font-semibold mb-4">
                  {product.name}
                </h3>
                <p className="text-muted-foreground mb-6">
                  {product.description}
                </p>
                <ul className="space-y-2">
                  {product.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-start">
                      <span className="text-primary mr-2">✓</span>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-primary/5">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-heading font-bold mb-4">
            Consulenza specializzata
          </h2>
          <p className="text-xl text-muted-foreground mb-8 max-w-2xl mx-auto">
            Offriamo supporto tecnico per aiutarti a scegliere i mangimi più adatti
            al tuo allevamento e alle tue esigenze produttive.
          </p>
          <Link
            to="/#contatti"
            className="inline-block px-8 py-3 bg-primary text-primary-foreground rounded-lg hover:opacity-90 transition-opacity"
          >
            Contattaci
          </Link>
        </div>
      </section>

      <ContactSection />
      <Footer />
    </div>
  );
};

export default MangimiAllevamento;
